import http from '../services/http';

const signatureProfiles = {
  profilesIndex(tableFilters) {
    return http.request({
      method: 'get',
      url: '/signature-profiles',
      params: { filter: { ...tableFilters } },
    });
  },
  profilesCount() {
    return http.request({
      method: 'get',
      url: '/signature-profiles/count',
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/signature-profiles/${id}`,
      data,
    });
  },
};

export default signatureProfiles;
